import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { NotificationManager } from 'react-notifications';
import { useAccessToken } from '../../../components/common/hooks/useAccessToken';
import { isAdminSelector } from '../../../components/store/auth/selectors';
import { showLoader, hideLoader } from '../../../components/store/common/slice';
import { calcMonthsTextForSelectBox } from '../../../components/common/shared/statelessMethods';
import { StyledSearchButton } from '../SearchForm/SearchForm.styled';
import { StyledActionScreensWrapper } from './PlanActionsScreens.styled';
import OnePayment from './OnePayment/OnePayment';

const PlanActionsScreens = () => {
    const dispatch = useDispatch();
    const client = useAccessToken();
    const isAdmin = useSelector(isAdminSelector);
    const updateBtnDisabled = useSelector(state => state.admin.updateBtnDisabled);
    const planScreensDataToSend = useSelector(state => state.admin.planScreensDataToSend)
    const { t } = useTranslation();

    const [data, setData] = useState({
        isOffline: null,
        months: '',
        installmentsPlan: {},
        buildingId: '',
        isOneTimePlan: null,
        address: '',
        planId: ''
    });

    const parseInstallmentsInfo = installmentsArr => {
        let parsedObject = {};
            installmentsArr.map(item => {
                let monthsObject = {};
                item.months.map(month => {
                    const dateObj = new Date(month.createdAt);
                    const currentDay = dateObj.getDate();
                    const currentMonth = dateObj.getMonth() + 1;
                    const currentYear = dateObj.getFullYear();
                    return monthsObject = {
                        ...monthsObject,
                        [month.id]: {
                            sum: month.sum,
                            date: month.createdAt,
                            parsedDate: {
                                value: `${currentYear}-${currentMonth}-${currentDay}`,
                                label: `${currentDay}/${currentMonth}/${currentYear}`,
                                name: month.id
                            },
                            paymentPlanDetailId: month?.PaymentPlanDetailId
                        }
                    }
                }
            )

            return parsedObject = {
                ...parsedObject,
                [item.months[0]?.PaymentPlanDetailId]: {
                    date: item.dateToCharge,
                    sum: item.amount,
                    status: item.status,
                    months: monthsObject,
                }
            }
        });
        return parsedObject;
    };

    const getPlanId = () => {
        const pathArr = window.location.pathname.split('/');
        const id = pathArr[pathArr.length-1];
        setData({
            ...data,
            planId: id
        });
    };

    const fetchData = async () => {
        let response = await client.get(`/tenants/order/${data.planId}`, { includeData: true });
        let installment;

        const { onGoingInstallments, oneTimePaymentsInstallments, pastPaymentsInstallments } = response.installments_details;

        if (onGoingInstallments) installment = onGoingInstallments[0];
        else if (oneTimePaymentsInstallments) installment = oneTimePaymentsInstallments[0];
        else if (pastPaymentsInstallments) installment = pastPaymentsInstallments[0];

        const {
            selectedMonths,
            installmentsPlan,
            isOffline,
        } = installment;

        setData({
            ...data,
            address: response.apartment_details.title,
            isOffline: isOffline,
            months: selectedMonths ? calcMonthsTextForSelectBox(selectedMonths) : null,
            isOneTimePlan: !selectedMonths,
            installmentsPlan: installmentsPlan ? parseInstallmentsInfo(installmentsPlan) : null,
        });
    };

    useEffect(() => {
        (async function () {
            dispatch(showLoader());

            getPlanId();

            dispatch(hideLoader());
        })();
    }, []);

    useEffect(() => {
        (async function () {
            if (!client) return;

            dispatch(showLoader());
            if (data.planId) await fetchData()
            dispatch(hideLoader());
        })();
    }, [client, data.planId]);

    const sendData = async () => {
        const response = await client.post(`/operations/update-plan/${data.planId}`, planScreensDataToSend);

        if (response) NotificationManager.success(t('searchPayments.notifications.dataSent'))
        else NotificationManager.error(t('searchPayments.notifications.failure'))
    };

    if (!isAdmin) return <div />;

    return (
        <StyledActionScreensWrapper>
            <div>
                <strong>{data.address}</strong>
                {t('searchPayments.planActionSubheaders.buildingAddress')}
            </div>
            {!data.isOneTimePlan && <div>{t('searchPayments.planActionSubheaders.planMonths')} <strong>{data.months}</strong></div>}

            <div className="payments">
                {Object.keys(data.installmentsPlan).map((item, i) => {
                    const plan = data.installmentsPlan[item];
                    return <OnePayment
                                key={i}
                                amount={plan.sum}
                                date={plan.date}
                                status={plan.status}
                                months={plan.months}
                                planId={data.planId}
                            />
                })}
            </div>
            <StyledSearchButton disabled={updateBtnDisabled} onClick={sendData}>{t('searchPayments.btns.update')}</StyledSearchButton>
        </StyledActionScreensWrapper>
    );
};

export default PlanActionsScreens;
